module.exports = __webpack_public_path__ + "static/media/052dead1.jpg";